import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { ConfigService } from '../../services/config/config.service';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { TimesheetAndExpensesUtilities } from '../../utilities/timesheet-and-expenses-utilities';
import { DateModelOptions } from '../options/date-model-options';
import { RadioModelOptions } from '../options/radio-model-options';
import { TimeModelOptions } from '../options/time-model-options';
import { DateModel } from '../primitive/date.model';
import { TextModel } from '../primitive/text.model';
import { TimeModel } from '../primitive/time.model';
import { CompositeModel } from './composite.model';
import { RadioModel } from './radio.model';
import { getNextTimesheetEntryCounter } from './timesheet-entry-counter';
import { TimesheetEntryInterface } from './timesheet-entry.interface';

export class TimesheetSowModel extends CompositeModel implements TimesheetEntryInterface {
    public startDate: DateModel;
    public startTime: TimeModel;
    public endDate: DateModel;
    public endTime: TimeModel;
    public startAddressOptions: RadioModel<TextModel>;

    public readonly index: number;
    public constructor(
        time: moment.Moment,
        firstTimesheetEntryStart: moment.Moment,
        previousEndOfWork: moment.Moment,
        startAddress: string,
    ) {
        super('TimesheetSoWModel');

        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigService);
        const timesheetAndExpensesUtilities = injector.get(TimesheetAndExpensesUtilities);
        this.index = getNextTimesheetEntryCounter();

        const maxValue = firstTimesheetEntryStart.isValid()
            ? firstTimesheetEntryStart
            : moment().add(ConfigConstants.maxAmountOfYears, 'years').startOf('minute');

        // If the SOW is for a submitted timesheet, don't place validation restriction (make restriction as loose as possible)
        const minValue = previousEndOfWork.isValid() ? previousEndOfWork : moment(0).startOf('minute');

        this.startDate = new DateModel('StartDate', time, new DateModelOptions({ minValue, maxValue }));
        this.startTime = new TimeModel('StartTime', time, new TimeModelOptions({ minValue, maxValue }));
        this.endDate = new DateModel('EndDate', time, new DateModelOptions({ minValue, maxValue }));
        this.endTime = new TimeModel('EndTime', time, new TimeModelOptions({ minValue, maxValue }));

        if (configService.getDisplayTimesheetAddressOptions()) {
            this.startAddressOptions = <RadioModel<TextModel>>this.set(
                new RadioModel<TextModel>(
                    'AddrNumber',
                    timesheetAndExpensesUtilities.getTimesheetAddressOptions(),
                    new RadioModelOptions({
                        initialSelection: 2,
                    }),
                ),
            );
            this.startAddressOptions.selectByPredicate((entry) => startAddress === entry.model.value);
        }
    }
}
